import { extendTheme } from '@chakra-ui/react';
import { rawTheme } from '@zap-onboard/web-components';

export const theme = extendTheme(rawTheme);
